module.exports = __webpack_public_path__ + "resources/img/img_hi_psm2_m_jp.4bfc1701d34ee7c6fe3f16d594c2b71c.png";